import React, { useState, ChangeEvent, useEffect } from 'react';
import { useAppDispatch, useAppSelector } from "../../../utils/Hooks";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import { getUsers } from "../../../store/reducers/UsersSlice";
import {Option} from "../../common/form/ElogSelect";
import {getEmails} from "../../../store/reducers/EmailsSlice";
import DatePicker from "react-datepicker";
import dayjs from "dayjs";

const TopClientsSearch: React.FC = () => {

    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const { search } = useLocation();
    const routeParams = useParams();

    const firstDayOfMonth = dayjs().startOf('month').format('DD.MM.YYYY');
    const currentDate = dayjs().format('DD.MM.YYYY');

    const [fromDate, setFromDate] = useState<string>(firstDayOfMonth);
    const [toDate, setToDate] = useState<string>(currentDate);
    const [perPage, setPerPage] = useState<number>(10);

    useEffect(() => {

        const urlParams = new URLSearchParams(window.location.search);

        const from = urlParams.get("fromDate");
        const to = urlParams.get("toDate");
        const perPageParam = urlParams.get("perPage");

        setFromDate(urlParams.get("fromDate") || '');
        setToDate(urlParams.get("toDate") || '');
        setPerPage(parseInt(urlParams.get("perPage") || '10'));

        if (!from && !to && !perPageParam) {
            navigate(`/top-clients?fromDate=${fromDate}&toDate=${toDate}&perPage=${perPage}`);
        } else {
            setFromDate(from || '');
            setToDate(to || '');
            setPerPage(parseInt(perPageParam || '10', 10));
        }

    }, []);

    const handleSearch = () => {
        const searchParams = new URLSearchParams();

        searchParams.set("fromDate", fromDate);
        searchParams.set("toDate", toDate);
        searchParams.set("perPage", String(perPage));

        const newUrl = `/top-clients?fromDate=${fromDate}&toDate=${toDate}&perPage=${perPage}`;

        navigate(newUrl);
    };

    return (
        <form>
            <div className="filter clear" style={{ width: '99%' }}>
                <div className="content" style={{ width: '100%' }}>
                    <p>
                        <span style={{display: 'inline-flex'}}>
                        <label><strong>Periood:</strong></label>
                        <DatePicker
                            autoComplete={'off'}
                            key={'from'}
                            value={fromDate}
                            onChange={(date) => setFromDate(date ? dayjs(date).format('DD.MM.YYYY') : '')}
                            dateFormat={'dd.MM.yyyy'}
                            className={'date'}
                            locale="et"
                            showYearDropdown={true}
                            showMonthDropdown={true}
                        />
                        –
                        <DatePicker
                            autoComplete={'off'}
                            key={'to'}
                            value={toDate}
                            onChange={(date) => setToDate(date ? dayjs(date).format('DD.MM.YYYY') : '')}
                            dateFormat={'dd.MM.yyyy'}
                            className={'date'}
                            locale="et"
                            showYearDropdown={true}
                            showMonthDropdown={true}
                        />
                        </span>
                        &nbsp;&nbsp;&nbsp;
                        <label><strong>Kirjeid lehel:</strong></label>
                        <input type="text" name="perPage" value={perPage} onChange={(e) => setPerPage(parseInt(e.target.value))} />
                    </p>
                </div>
                <p className="action">
                    <button type="button" onClick={handleSearch}><span><strong>Vali</strong></span></button>
                </p>
            </div>
        </form>
    );
};

export default TopClientsSearch;